module.exports = __webpack_public_path__ + "img/get-it-from-MS_222x80.d645112b.png";